import { render, staticRenderFns } from "./notifications-panel.vue?vue&type=template&id=744f6868&scoped=true"
import script from "./notifications-panel.vue?vue&type=script&lang=js"
export * from "./notifications-panel.vue?vue&type=script&lang=js"
import style0 from "./notifications-panel.vue?vue&type=style&index=0&id=744f6868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f6868",
  null
  
)

export default component.exports